import React, { useState, useRef, useEffect } from "react";
import 'react-toastify/dist/ReactToastify.css';
import { getTrans as t } from "../../../../Localization/translations";
import Tooltip from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import CheckButton from "react-validation/build/button";
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import Form from "react-validation/build/form";
import { useForm } from "react-hook-form";
import { ToastContainer, toast } from 'react-toastify';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from "axios";

import AddPartyContactService from '../../../../services/party/contact/addContactParty';
import ButtonLoading from "../../../../components/Loder/buttonLoading";
import EditPartyService from "../../../../services/party/editParty.service";
import EditContactService from "../../../../services/party/contact/editContactService";
import { API } from "../../../../backend";
import authHeader from "../../../../services/auth-header";

function Partycontact({ id, setContactEmail, setContactId, contact = null, setTab = null, partyType, setHideShowParyContact }) {

  const [prefix, setPrefix] = useState("")
  const [first_name, setFirst_name] = useState("")
  const [middle_name, setMiddle_name] = useState("")
  const [last_name, setLast_name] = useState("")
  const [phone_number, setPhone_number] = useState("")
  const [mobile_number, setMobile_number] = useState("")
  const [email, setEmail] = useState("")
  const [createuser, setCreateuser] = useState(false)
  const [partycustomer, setPartyCustomer] = useState('')

  const [successful, setSuccessful] = useState(false);
  const [loading, setLoading] = useState(false);
  const [disable, setDisable] = useState(false)


  let navigate = useNavigate();
  const checkBtn = useRef();
  const { register, handleSubmit, formState: { errors }, reset,
  } = useForm();
  const form = useRef();
  const location = useLocation();
  const data = location.state?.data
  let usercreate = ''
  const handleCancel = () => {
    if (setTab) {
      if (partyType.includes("Customer")) {

        setTab(3)
      }
      else {
        navigate("/party/details", { state: id })
      }
    }
    else {
      // setHideShow(true)
      setHideShowParyContact(false)

    }
  }
  const getparty = () => {
    EditPartyService.getParty(id).then(
      (response) => {
        setPrefix(response.data.prefix)
        setFirst_name(response.data.first_name)
        setMiddle_name(response.data.middle_name)
        setLast_name(response.data.last_name)
        setPartyCustomer(response.data.party_type)

        reset({
          prefix: response.data.prefix,
          first_name: response.data.first_name,
          last_name: response.data.last_name,
          email: response.data.email,
          phone_number: response.data.phone_number,
        })
      }
    )

  }
  useEffect(() => {
    if (id !== null) {
      if (contact !== null) {

      }
      else {

        getparty()
      }
    }
  }, [])

  const handleCreateuser = (e) => {
    if (e.target.checked === true) {
      usercreate = 'Yes'
      axios.post(API + "parties/useremailvalidation/", {
        email,

      }, { headers: authHeader(), }).then((response) => {
        if (response.data.success === 0) {

          toast.error(`${response.data.error}`, {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          })
          setCreateuser(false)
        }
        else {
          setCreateuser(true)
        }
      })
    }
    else {
      usercreate = 'No'
      setCreateuser(e.target.checked)
    }
  }

  const handleRegister = () => {
    if (contact !== null) {
      handleupdatecontact()
    }
    else {
      setSuccessful(false);
      setLoading(true)
      setDisable(true)
      form.current.validateAll();
      if (checkBtn.current.context._errors.length === 0) {
        if (id !== null) {
          id = id
        }
        else {
          id = data
        }
        if (createuser === true) {
          usercreate = 'Yes'
        }
        else {
          usercreate = 'No'
        }
        AddPartyContactService.addPartyContact(
          id,
          prefix,
          first_name,
          middle_name,
          last_name,
          phone_number,
          mobile_number,
          email,
          usercreate
        ).then(
          (response) => {
            if (response.data.success) {
              setSuccessful(true);
              if (setTab) {
                setContactEmail(email)
              }
              setTimeout(() => {
                // setHideShowEdit(true)
                setHideShowParyContact(false)
              }, 2000)
              toast.success(`${response.data.response}`, {
                position: "top-right",
                autoClose: 1000,
                hideProgressBar: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              })
              setLoading(false)
              setTimeout(() => {

                if (setTab) {
                  setContactId(response.data.contactId)
                  if (partyType.includes("Customer")) {

                    setTab(3)
                  } else {
                    setTab(2)
                  }
                }
                else {
                  // setHideShow(true)/
                  setHideShowParyContact(false)
                }
              }, 2000)
            }
            else {
              toast.error(`${response.data.error}`, {
                position: "top-right",
                autoClose: 1000,
                hideProgressBar: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              })
              setSuccessful(false);
              setLoading(false)

            }
          },
        )
      }
    }
  }

  useEffect(() => {
    if (contact !== null) {

      EditContactService.getPartyContactDetails(contact).then(
        (response) => {
          setPrefix(response.data.prefix)
          setFirst_name(response.data.first_name)
          setMiddle_name(response.data.middle_name)
          setLast_name(response.data.last_name)
          setPhone_number(response.data.phone_number)
          setMobile_number(response.data.mobile_number)
          setEmail(response.data.email)
          setCreateuser(response.data.createpartyuser)

          reset({
            prefix: response.data.prefix,
            first_name: response.data.first_name,
            last_name: response.data.last_name,
            email: response.data.email,
            phone_number: response.data.phone_number,
          })
        },
      )
    }
  }, [contact, reset])

  const handleupdatecontact = () => {
    setSuccessful(false);
    setLoading(true)
    if (createuser === true) {
      usercreate = 'Yes'
    }
    else {
      usercreate = 'No'
    }
    form.current.validateAll();
    if (checkBtn.current.context._errors.length === 0) {
      EditContactService.editPartyContactDetails(
        contact,
        prefix,
        first_name,
        middle_name,
        last_name,
        phone_number,
        mobile_number,
        email,
        usercreate
      ).then(
        (response) => {
          if (response.data.success) {
            setSuccessful(true);
            setLoading(false);
            setContactEmail(email)
            toast.success(`${response.data.response}`, {
              position: "top-right",
              autoClose: 1000,
              hideProgressBar: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            })
          }
          else {
            toast.error(`${response.data.error}`, {
              position: "top-right",
              autoClose: 1000,
              hideProgressBar: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            })
            setSuccessful(false);
            setLoading(false)

          }
        },
      )
    }
  }


  return (
    <>
      {
        <div>
          <div className="container-fluid">
            <ToastContainer />
            <div className="header pb-0 mb-3">
              <h5 className="modal-title text-left">{t('Contact Details')}</h5>
            </div>
            <div className="card" role="document">
              <div className="card-body">
                <div className="row">
                  <div className="col-md-12">
                    <Form role="form text-left"
                      onSubmit={handleSubmit(handleRegister)}
                      ref={form}
                      action="."
                      method="POST"
                      id="addPartyContactForm" >
                      {(
                        <>
                          <div className="form-group row">
                            <div className="col-sm-3">
                              <label className="col-form-label">{t('Prefix')} <Tooltip content={t('Prefix_Tooltip')}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                              <select
                                {...register("prefix", { required: false })}
                                onChange={(e) => setPrefix(e.target.value)}
                                value={prefix}
                                className="form-control form-select"
                                name="prefix"
                                id="id_prefix"
                              >
                                <option value="" selected="">{t('Select Prefix')}</option>
                                <option value="Mr">{t('Mr')}</option>
                                <option value="Mrs">{t('Mrs')}</option>
                                <option value="Ms">{t('Ms')}</option>
                              </select>
                              <div className="invalid-feedback">
                                {errors.prefix?.type === 'required' && "Prefix is required"}
                              </div>
                            </div>
                            <div className="col-sm-3">
                              <label className="col-form-label required">{t('First Name')} <Tooltip content={t('FirstName_Tooltip')}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                              <input
                                value={first_name}
                                placeholder={t('First Name')}
                                className="form-control"
                                type="text"
                                name="first_name"
                                id="id_first_name"
                                {...register("first_name", { onChange: (e) => setFirst_name(e.target.value), required: true })}
                              />
                              <div className="invalid-feedback">
                                {errors.first_name?.type === 'required' && "First Name is required"}
                              </div>
                            </div>
                            <div className="col-sm-3">
                              <label className="col-form-label">{t('Middle Name')} <Tooltip content={t('MiddleName_Tooltip')}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                              <input
                                {...register("middle_name", { required: false })}
                                onChange={(e) => setMiddle_name(e.target.value)}
                                value={middle_name}
                                placeholder={t('Middle Name')}
                                className="form-control"
                                type="text"
                                name="middle_name"
                                maxLength="100"
                                id="id_middle_name"
                              />
                            </div>
                            <div className="col-sm-3">
                              <label className="col-form-label required">{t('Last Name')} <Tooltip content={t('LastName_Tooltip')}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                              <input
                                value={last_name}
                                placeholder={t('Last Name')}
                                className="form-control"
                                type="text"
                                name="last_name"
                                id="id_last_name"
                                {...register("last_name", { onChange: (e) => setLast_name(e.target.value), required: true })}
                              />
                              <div className="invalid-feedback">
                                {errors.last_name?.type === 'required' && "Last Name is required"}
                              </div>
                            </div>
                          </div>
                          <div className="form-group row">
                            <div className=" col-md-3">
                              <label className="col-form-label">{t('Phone No')} <Tooltip content={t('PhoneNo_Tooltip')}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                              <PhoneInput
                                country={'us'}
                                value={phone_number}
                                onChange={phone => setPhone_number(phone)}
                              />
                              <div className="invalid-feedback">
                                {errors.phone_number?.type === 'required' && "Phone Number is required"}
                              </div>
                            </div>

                            <div className="col-md-3">
                              <label className="col-form-label">{t('Mobile No')} <Tooltip content={t('MobileNo_Tooltip')}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                              <input
                                {...register("mobile_number", { required: false })}
                                onChange={(e) => setMobile_number(e.target.value)}
                                value={mobile_number}
                                placeholder={t('Mobile No')}
                                className="form-control"
                                type="text"
                                name="mobile_number"
                                maxLength="15"
                                id="id_mobile_number"
                              />
                            </div>
                          </div>
                          <div className="row ">
                            <div className="col-md-3">
                              <label className="col-form-label required">{t('Email Address')} <Tooltip content={t('EmailAddress_Tooltip')}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                              <input
                                value={email}
                                placeholder={t('Email Address')}
                                className="form-control"
                                type="email"
                                name="email"
                                maxLength="50"
                                id="id_email"
                                {...register('email', {
                                  onChange: (e) => { setEmail(e.target.value) }, required: "Email is Required",
                                  pattern: {
                                    value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                                    message: 'Please enter a valid Email'
                                  }
                                })}
                              />
                              <span className="invalid-feedback" >{errors.email && errors.email?.message}</span>
                            </div>
                            {
                              partycustomer.includes('Customer') ?

                                <div className="col-md-5">
                                  <div
                                    className="form-check"
                                    style={{ width: "100%", paddingLeft: "2.73em", paddingTop: "2.3em" }}
                                  >
                                    <input
                                      className="form-check-input"
                                      value="Yes"
                                      type="checkbox"
                                      name="Vehicle"
                                      id="flexRadioDefault1"
                                      checked={createuser === true}
                                      onChange={(e) => handleCreateuser(e)}
                                    />
                                    <label className="form-check-label tc  font-weight-bold">{t('Customer Portal')}</label>
                                  </div>
                                </div>
                                : ""
                            }
                          </div>

                          <div className="text-left py-3">
                            <button type="button" className="btn btn-secondary btn-md" onClick={handleCancel}>
                              {/* {setTab !== null ? t('Skip') : t('Cancel')} */}
                              {setTab !== null ? t('Cancel') : t('Cancel')}
                            </button>&nbsp;&nbsp;
                            <button type="submit" disabled={disable} className="border-0 btn btn-primary btn-gradient-primary btn-md">
                              {
                                loading === false ? (
                                  setTab !== null ?
                                    // t('Save & Continue') :
                                    t('Save') :
                                    t('Save')
                                ) : (
                                  <ButtonLoading />
                                )
                              }
                            </button>
                          </div>
                        </>
                      )}
                      <CheckButton style={{ display: "none" }} ref={checkBtn} />
                    </Form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    </>
  )
}

export default Partycontact

